module.exports = __webpack_public_path__ + "img/product_61.fee5212.svg";